import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import BlankState from '../../../components/BlankState';
import StatusMessages from '../../../components/StatusMessages';

import { updateInsurer, saveInsurer } from '../../../actions/insurers';

class InsurerForm extends Component{
    
    constructor(props){
        super(props);
        
        this.state = {
            insurer: {
                ...this.props.insurer
            },
            insurer_updating: false,
            has_errors: false
        };
    }
    
    componentWillReceiveProps(nextProps){
        const { insurer } = nextProps;

        this.setState({
            insurer: insurer || {},
            updated_insurer: {
                id: insurer ? insurer.id : ''
            },
        });
    }


    handleSubmission = (e) => {
        e.preventDefault();

        this.setState({ insurer_updating: true })

        const { insurer, updated_insurer } = this.state;
        let handler = {};

        if(insurer.hasOwnProperty('id')){
            handler = this.props.updateInsurer(updated_insurer);
        }
        else{
            handler = this.props.saveInsurer(insurer);
        }

        handler
            .then((response)=>{
                this.setState({ insurer_updating: false });
            })
            .catch((error)=>{
                this.setState({ insurer_updating: false });
            });
    }

    onChange = (e) => {
        e.preventDefault();

        const { updated_insurer, insurer } = this.state;
        const { name, value } = e.target;

        this.setState({ 
            updated_insurer: {
                ...updated_insurer,
                [name]: value
            },
            insurer: {
                ...insurer,
                [name]: value
            },
        });
    }
    
    onAddFiles = (e) => {
        e.preventDefault();

        const { updated_insurer , insurer } = this.state;
        const { name, files } = e.target;

        this.setState({
            updated_insurer: {
                ...updated_insurer,
                [name]: files[0]
            },
            insurer: {
                ...insurer,
                [name]: files[0]
            }
        })
    }

    render(){
        console.log(this.state);
        console.log(this.props);
        
        const { insurer, insurer_updating } = this.state;
        const { insurers, edit } = this.props;

        return(
            <div className="add-goods-form">
                {
                    insurers.errorMessageInsurerForm && edit && ! insurer_updating ?
                        <StatusMessages 
                            type="error"
                            message={ insurers.errorMessageInsurerForm } />
                    :
                        null
                }
                {
                    insurers.successInsurerForm && edit && ! insurer_updating ?
                        <StatusMessages 
                            type="success" 
                            message={ insurers.successMessage } />
                    :
                        null
                }
                <BlankState 
                    data={ false }
                    isDataLoading={ insurer_updating }
                    customMessage="Saving..." />

                <form className="form form-horizontal"
                    onSubmit={ this.handleSubmission }>

                    <div className="form-group">
                        <label className="control-label col-sm-4">Company Name:</label>
                        <div className="col-sm-8">
                        
                        <input 
                            type="text" 
                            name="company_name" 
                            value={ insurer.company_name || ''} 
                            onChange={ this.onChange } 
                            className="form-control"
                            required 
                            autoFocus />
					
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4">Company Logo:</label>
                        <div className="col-sm-8">

                        <input 
                            type="file" 
                            name="company_logo" 
                            onChange={ this.onAddFiles }
                            required={ !edit }
                            autoFocus/>
                           
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4">Company Code:</label>
                        <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="company_code" 
                            value={ insurer.company_code || ''} 
                            onChange={ this.onChange } 
                            className="form-control"
                            required 
                            autoFocus/>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4"> Company TIN:</label>
                        <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="company_tin" 
                            value={ insurer.company_tin || ''} 
                            onChange={ this.onChange } 
                            className="form-control"
                            required 
                            autoFocus/>

                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4">Postal Address:</label>
                        <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="postal_address" 
                            value={ insurer.postal_address || ''} 
                            onChange={ this.onChange } 
                            className="form-control"
                            required 
                            autoFocus/>

                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4">Physical Address:</label>
                        <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="physical_address" 
                            value={ insurer.physical_address || ''} 
                            onChange={ this.onChange } 
                            className="form-control"
                            required 
                            autoFocus/>

                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4"> Bank Account: </label>
                        <div className="col-sm-8">
                        <input 
                            type="number" 
                            name="bank_account_number" 
                            value={ insurer.bank_account_number } 
                            onChange={ this.onChange } 
                            className="form-control"
                            required={ !edit }
                            autoFocus/>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4">Bank Name: </label>
                        <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="bank_name" 
                            value={ insurer.bank_name || ''} 
                            onChange={ this.onChange } 
                            className="form-control"
                            required={ !edit } 
                            autoFocus/>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4"> Authorized Signature: </label>
                        <div className="col-sm-8">
                        <input 
                            type="file" 
                            name="authorized_signature" 
                            onChange={ this.onAddFiles }
                            required={ !edit } 
                            autoFocus/>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4">Phone Number: </label>
                        <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="phone" 
                            value={ insurer.phone || ''} 
                            onChange={ this.onChange } 
                            className="form-control" 
                            required 
                            autoFocus/>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4"> Email Address: </label>
                        <div className="col-sm-8">
                        <input 
                            type="email" 
                            name="email" 
                            value={ insurer.email || ''} 
                            onChange={ this.onChange } 
                            className="form-control"
                            required 
                            autoFocus
                            />
                            
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="control-label col-sm-4">Policy Document: </label>
                        <div className="col-sm-8">
                        <input 
                            type="file" 
                            name="policy_document" 
                            onChange={ this.onAddFiles }
                            required={ !edit } 
                            autoFocus/>
                        </div>
                    </div>

                    <div className="col-sm-offset-4">
                        <div className="col-sm-12">
                        {
                            insurer.hasOwnProperty('id') ?
                                <button className="btn btn-warning" >
                                    <i className="icon ion-edit"></i>&nbsp; Update
                                </button>
                            :
                                <button className="btn btn-success">
                                    <i className="icon ion-checkmark"></i>&nbsp; Create
                                </button>
                        }
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    insurers: state.insurers
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ updateInsurer, saveInsurer }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(InsurerForm);



// WEBPACK FOOTER //
// ./src/pages/dashboard/insurers/InsurerForm.jsx